import PropTypes from 'prop-types'

const propTypes = {
  className: PropTypes.string
}

const SectionLine = ({ className }) => (
  <hr className={ `section-separator-line ${className}` } />
)

SectionLine.propTypes = propTypes

export default SectionLine
